import { createI18n } from "vue-i18n";
import es from "@/common/i18n/es";
import en from "@/common/i18n/en";

export const i18n = createI18n({
  legacy: false,
  locale: "es",
  fallbackLocale: "es",
  messages: { es, en },
});
